import React from 'react';
import Message from './Message';

// import './slick-settings.css'
import './slick-settings_custom.css'

const ChatServiceBoard = (props) => {
  const { messages, editMessageIndex, editRowIndex, editSlidePageIndex, currentEditSlidePage, effectFlag } = props

  return (
    <div className="chat-service-board" style={{width: '100%'}}>
      {
        messages.map((message, i) => {
          const effectFlag_message = effectFlag && editMessageIndex === i
          return ( 
            <Message key={i} i={i} rows={message.rows} {...props} messages={null} effectFlag={effectFlag_message} />
          )
        })
      }
    </div>
  )
}

export default ChatServiceBoard